import { tCommon } from "@/shared/config/i18n"
import { Button } from "@/shared/ui/button"
import { cn } from "@/shared/utils"

interface IProps {
  label?: string
  fileName: string
  onDownload: () => void
  className?: string
  disabled?: boolean
  loading?: boolean
}

export const DownloadableFile = ({ label, fileName, onDownload, loading, disabled, className }: IProps) => {
  return (
    <div>
      {label && <label className="text-gray-800 text-sm">{label}</label>}
      <div className={cn("flex", className)}>
        <div className={cn("flex flex-1 items-center overflow-hidden rounded-l-lg border px-4 py-3 ", loading ? "bg-zinc-100" : "")}>
          {/* <Download4 size={18} className="mr-2 text-blue-500" /> */}
          <span className="overflow-hidden text-ellipsis text-nowrap text-blue-500 text-sm">{fileName}</span>
        </div>
        <Button
          disabled={disabled}
          loading={loading}
          className="h-auto rounded-l-none bg-[#D6DEE7] text-[#222222] text-sm hover:bg-[#D6DEE7] hover:text-[#222222]"
          onClick={onDownload}
        >
          {tCommon("download")}
        </Button>
      </div>
    </div>
  )
}
